import { useState, useEffect } from 'react'

interface BreakpointState {
  isMobile: boolean
  isTablet: boolean
  isDesktop: boolean
}

const breakpoints = {
  mobile: 768,
  tablet: 1024
}

const getBreakpointState = (): BreakpointState => {
  if (typeof window === 'undefined') {
    return { isMobile: false, isTablet: false, isDesktop: false }
  }

  const isMobile = window.matchMedia(
    `(max-width: ${breakpoints.mobile - 1}px)`
  ).matches
  const isTablet = window.matchMedia(
    `(min-width: ${breakpoints.mobile}px) and (max-width: ${
      breakpoints.tablet - 1
    }px)`
  ).matches
  const isDesktop = window.matchMedia(
    `(min-width: ${breakpoints.tablet}px)`
  ).matches

  return { isMobile, isTablet, isDesktop }
}

const useBreakpoint = (): BreakpointState => {
  // Set the initial state based on the current screen size
  const [breakpoint, setBreakpoint] =
    useState<BreakpointState>(getBreakpointState)

  useEffect(() => {
    const handleResize = () => {
      setBreakpoint(getBreakpointState())
    }

    const tabletBoundaryQuery = window.matchMedia(
      `(min-width: ${breakpoints.mobile}px)`
    )
    const desktopBoundaryQuery = window.matchMedia(
      `(min-width: ${breakpoints.tablet}px)`
    )

    tabletBoundaryQuery.addEventListener('change', handleResize)
    desktopBoundaryQuery.addEventListener('change', handleResize)

    return () => {
      tabletBoundaryQuery.removeEventListener('change', handleResize)
      desktopBoundaryQuery.removeEventListener('change', handleResize)
    }
  }, [])

  return breakpoint
}

export default useBreakpoint
